import React, {memo} from "react";
import {getDate} from "../helper/dateUtils";


const HeadingDate = ({date}) => {
    return <th colSpan="5" className="text-center">
        <h2 className="heading">ឆ្នោតចេញថ្ងៃ {getDate(date)}</h2>
    </th>
}

export default memo(HeadingDate);